import { B3SelectItem } from 'src/app/shared/models/b3-select-item.model';

/** Mapeamento baseline → metodologia (ids podem variar por ambiente: DEV usa 2, QAA usa 4). */
const PSA_BASELINE_TO_METHODOLOGY_ID: Readonly<Record<number, number>> = {
  1: 1, // Conservação Florestal → PSA Carbonflor
  2: 2, // Conservação e práticas agrícolas (DEV) → PSA Carbon Agro Perene
  4: 2, // Conservação e práticas agrícolas (QAA) → PSA Carbon Agro Perene
};

const PSA_METHODOLOGY_TO_BASELINE_IDS: Readonly<Record<number, readonly number[]>> = {
  1: [1],
  2: [2, 4],
};

export function resolvePsaSelectItemId(
  value: B3SelectItem | { inputId?: number | string | null } | number | string | null | undefined,
): number | null {
  if (value == null || value === '') {
    return null;
  }

  const rawId = typeof value === 'object' ? value.inputId : value;
  const numericId = Number(rawId);

  return Number.isFinite(numericId) ? numericId : null;
}

export function findPsaSelectItemById(
  options: B3SelectItem[],
  id: number | null,
): B3SelectItem | null {
  if (id == null) {
    return null;
  }

  return options.find(option => option.inputId == id) ?? null;
}

export function resolvePsaMethodologyIdFromBaselineId(baselineId: number | null): number | null {
  if (baselineId == null) {
    return null;
  }

  return PSA_BASELINE_TO_METHODOLOGY_ID[baselineId] ?? null;
}

export function resolvePsaBaselineIdFromMethodologyId(
  methodologyId: number | null,
  baselineOptions: B3SelectItem[] = [],
): number | null {
  if (methodologyId == null) {
    return null;
  }

  const candidates = PSA_METHODOLOGY_TO_BASELINE_IDS[methodologyId];
  if (!candidates?.length) {
    return null;
  }

  if (baselineOptions.length) {
    const matched = candidates.find(id => findPsaSelectItemById(baselineOptions, id));
    if (matched != null) {
      return matched;
    }
  }

  return candidates[0];
}

export function isPsaBaselineMethodologyPairValid(
  baselineId: number | null,
  methodologyId: number | null,
): boolean {
  if (baselineId == null || methodologyId == null) {
    return false;
  }

  const expectedMethodologyId = resolvePsaMethodologyIdFromBaselineId(baselineId);
  return expectedMethodologyId != null && expectedMethodologyId === methodologyId;
}

export function getPsaInvalidBaselineMethodologyMessage(): string {
  return 'A atividade de baseline deve corresponder à metodologia selecionada. Conservação Florestal (baseline 1) exige PSA Carbonflor (metodologia 1); Conservação e práticas agrícolas (baseline 2 ou 4) exige PSA Carbon Agro Perene (metodologia 2).';
}

export function buildPsaSelectItemStub(id: number, label = ''): B3SelectItem {
  return { inputId: id, label, data: id };
}
